var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.007,
    height: 31.124,
    viewBox: "0 0 31.007 31.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "call_1_",
    "data-name": "call (1)",
    d: "M32.835,26.025q-2.04-2.04-4.077-4.077a2.359,2.359,0,0,0-3.627,0Q23.859,23.22,22.583,24.5a.525.525,0,0,1-.68.113c-.512-.34-1.133-.567-1.645-.907a25.635,25.635,0,0,1-6.343-5.78,15.336,15.336,0,0,1-2.267-3.682.525.525,0,0,1,.113-.68c.907-.793,1.7-1.642,2.548-2.38a2.4,2.4,0,0,0,0-3.737c-.735-.739-1.36-1.36-2.036-2.04-.739-.735-1.419-1.415-2.1-2.1a2.433,2.433,0,0,0-3.623,0Q5.273,4.581,4,5.857A4.536,4.536,0,0,0,2.7,8.691a12.1,12.1,0,0,0,.907,5.1,30.233,30.233,0,0,0,5.5,9.177,33.574,33.574,0,0,0,11.272,8.841,17.247,17.247,0,0,0,6.175,1.813,4.726,4.726,0,0,0,3.967-1.532c.735-.793,1.587-1.528,2.322-2.322a2.482,2.482,0,0,0,0-3.74Z",
    transform: "translate(-2.677 -2.5)",
    fill: "#df9426"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumberIcon);
export default __webpack_public_path__ + "static/media/phone_Number_icon.33343d37bc25723e116d78151bc05431.svg";
export { ForwardRef as ReactComponent };